/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BcArticleListResponse } from '../models/bc-article-list-response';
import { BcArticleResponse } from '../models/bc-article-response';
import { BcProductCategoryResponsePaging } from '../models/bc-product-category-response-paging';
import { BcProductListResponse } from '../models/bc-product-list-response';
import { BcServiceDetailResponse } from '../models/bc-service-detail-response';
import { BcServiceListResponsePaging } from '../models/bc-service-list-response-paging';
import { BcSystemDetailResponse } from '../models/bc-system-detail-response';
import { BcSystemFamilyResponse } from '../models/bc-system-family-response';
import { BcSystemListResponse } from '../models/bc-system-list-response';
import { BcSystemVariantListResponse } from '../models/bc-system-variant-list-response';
import { getAllArticles } from '../fn/business-central/get-all-articles';
import { GetAllArticles$Params } from '../fn/business-central/get-all-articles';
import { getAllProducts } from '../fn/business-central/get-all-products';
import { GetAllProducts$Params } from '../fn/business-central/get-all-products';
import { getAllSystems } from '../fn/business-central/get-all-systems';
import { GetAllSystems$Params } from '../fn/business-central/get-all-systems';
import { getAllSystemVariants } from '../fn/business-central/get-all-system-variants';
import { GetAllSystemVariants$Params } from '../fn/business-central/get-all-system-variants';
import { GetBcProductResponse } from '../models/get-bc-product-response';
import { getBusinessCentralProductDetail } from '../fn/business-central/get-business-central-product-detail';
import { GetBusinessCentralProductDetail$Params } from '../fn/business-central/get-business-central-product-detail';
import { getBusinessCentralProductList } from '../fn/business-central/get-business-central-product-list';
import { GetBusinessCentralProductList$Params } from '../fn/business-central/get-business-central-product-list';
import { getBusinessCentralServices } from '../fn/business-central/get-business-central-services';
import { GetBusinessCentralServices$Params } from '../fn/business-central/get-business-central-services';
import { getBusinessCentralServicesSearch } from '../fn/business-central/get-business-central-services-search';
import { GetBusinessCentralServicesSearch$Params } from '../fn/business-central/get-business-central-services-search';
import { getProductArticles } from '../fn/business-central/get-product-articles';
import { GetProductArticles$Params } from '../fn/business-central/get-product-articles';
import { getSystemDetail } from '../fn/business-central/get-system-detail';
import { GetSystemDetail$Params } from '../fn/business-central/get-system-detail';
import { getSystems } from '../fn/business-central/get-systems';
import { GetSystems$Params } from '../fn/business-central/get-systems';

@Injectable({ providedIn: 'root' })
export class BusinessCentralService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllArticles()` */
  static readonly GetAllArticlesPath = '/business-central/articles/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllArticles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllArticles$Response(params?: GetAllArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcArticleListResponse>>> {
    return getAllArticles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllArticles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllArticles(params?: GetAllArticles$Params, context?: HttpContext): Observable<Array<BcArticleListResponse>> {
    return this.getAllArticles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BcArticleListResponse>>): Array<BcArticleListResponse> => r.body)
    );
  }

  /** Path part for operation `getAllProducts()` */
  static readonly GetAllProductsPath = '/business-central/products/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllProducts$Response(params?: GetAllProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcProductListResponse>>> {
    return getAllProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllProducts(params?: GetAllProducts$Params, context?: HttpContext): Observable<Array<BcProductListResponse>> {
    return this.getAllProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BcProductListResponse>>): Array<BcProductListResponse> => r.body)
    );
  }

  /** Path part for operation `getAllSystems()` */
  static readonly GetAllSystemsPath = '/business-central/systems/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSystems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSystems$Response(params?: GetAllSystems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcSystemListResponse>>> {
    return getAllSystems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSystems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSystems(params?: GetAllSystems$Params, context?: HttpContext): Observable<Array<BcSystemListResponse>> {
    return this.getAllSystems$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BcSystemListResponse>>): Array<BcSystemListResponse> => r.body)
    );
  }

  /** Path part for operation `getAllSystemVariants()` */
  static readonly GetAllSystemVariantsPath = '/business-central/systems/variants/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSystemVariants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSystemVariants$Response(params?: GetAllSystemVariants$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcSystemVariantListResponse>>> {
    return getAllSystemVariants(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSystemVariants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSystemVariants(params?: GetAllSystemVariants$Params, context?: HttpContext): Observable<Array<BcSystemVariantListResponse>> {
    return this.getAllSystemVariants$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BcSystemVariantListResponse>>): Array<BcSystemVariantListResponse> => r.body)
    );
  }

  /** Path part for operation `getBusinessCentralProductDetail()` */
  static readonly GetBusinessCentralProductDetailPath = '/business-central/product/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessCentralProductDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralProductDetail$Response(params: GetBusinessCentralProductDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBcProductResponse>> {
    return getBusinessCentralProductDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessCentralProductDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralProductDetail(params: GetBusinessCentralProductDetail$Params, context?: HttpContext): Observable<GetBcProductResponse> {
    return this.getBusinessCentralProductDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetBcProductResponse>): GetBcProductResponse => r.body)
    );
  }

  /** Path part for operation `getBusinessCentralProductList()` */
  static readonly GetBusinessCentralProductListPath = '/business-central/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessCentralProductList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralProductList$Response(params: GetBusinessCentralProductList$Params, context?: HttpContext): Observable<StrictHttpResponse<BcProductCategoryResponsePaging>> {
    return getBusinessCentralProductList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessCentralProductList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralProductList(params: GetBusinessCentralProductList$Params, context?: HttpContext): Observable<BcProductCategoryResponsePaging> {
    return this.getBusinessCentralProductList$Response(params, context).pipe(
      map((r: StrictHttpResponse<BcProductCategoryResponsePaging>): BcProductCategoryResponsePaging => r.body)
    );
  }

  /** Path part for operation `getBusinessCentralServices()` */
  static readonly GetBusinessCentralServicesPath = '/business-central-services';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessCentralServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralServices$Response(params: GetBusinessCentralServices$Params, context?: HttpContext): Observable<StrictHttpResponse<BcServiceListResponsePaging>> {
    return getBusinessCentralServices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessCentralServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralServices(params: GetBusinessCentralServices$Params, context?: HttpContext): Observable<BcServiceListResponsePaging> {
    return this.getBusinessCentralServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<BcServiceListResponsePaging>): BcServiceListResponsePaging => r.body)
    );
  }

  /** Path part for operation `getBusinessCentralServicesSearch()` */
  static readonly GetBusinessCentralServicesSearchPath = '/business-central-services-search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBusinessCentralServicesSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralServicesSearch$Response(params: GetBusinessCentralServicesSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcServiceDetailResponse>>> {
    return getBusinessCentralServicesSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBusinessCentralServicesSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBusinessCentralServicesSearch(params: GetBusinessCentralServicesSearch$Params, context?: HttpContext): Observable<Array<BcServiceDetailResponse>> {
    return this.getBusinessCentralServicesSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BcServiceDetailResponse>>): Array<BcServiceDetailResponse> => r.body)
    );
  }

  /** Path part for operation `getProductArticles()` */
  static readonly GetProductArticlesPath = '/business-central/product/{id}/articles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductArticles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductArticles$Response(params: GetProductArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcArticleResponse>>> {
    return getProductArticles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductArticles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductArticles(params: GetProductArticles$Params, context?: HttpContext): Observable<Array<BcArticleResponse>> {
    return this.getProductArticles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BcArticleResponse>>): Array<BcArticleResponse> => r.body)
    );
  }

  /** Path part for operation `getSystemDetail()` */
  static readonly GetSystemDetailPath = '/business-central/systems/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSystemDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemDetail$Response(params: GetSystemDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<BcSystemDetailResponse>> {
    return getSystemDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSystemDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemDetail(params: GetSystemDetail$Params, context?: HttpContext): Observable<BcSystemDetailResponse> {
    return this.getSystemDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BcSystemDetailResponse>): BcSystemDetailResponse => r.body)
    );
  }

  /** Path part for operation `getSystems()` */
  static readonly GetSystemsPath = '/business-central/systems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSystems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystems$Response(params?: GetSystems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcSystemFamilyResponse>>> {
    return getSystems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSystems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystems(params?: GetSystems$Params, context?: HttpContext): Observable<Array<BcSystemFamilyResponse>> {
    return this.getSystems$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BcSystemFamilyResponse>>): Array<BcSystemFamilyResponse> => r.body)
    );
  }

}
